import {InputSwitch} from "primereact/inputswitch";
import {FunctionComponentElement} from "react";
import {NodeInputProps} from "./index";


export const BooleanInput = (props: NodeInputProps): FunctionComponentElement<NodeInputProps> =>{
    return <InputSwitch disabled={props.disabled} checked={props.value === undefined ? props.defaultValue : props.value} onChange={(e) => {
        props.onChange(e.value);
    }}/>
}